"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "POPOVER_ARROW_POSITION", {
  enumerable: true,
  get: function get() {
    return _constants.ARROW_POSITION;
  }
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _boxShadowMixin = _interopRequireDefault(require("./boxShadowMixin"));

var _Arrow = _interopRequireWildcard(require("./Arrow"));

var _ArrowContainer = _interopRequireWildcard(require("./ArrowContainer"));

var _constants = require("./constants");

var _core = require("@emotion/core");

var PopoverStyle = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1einyzc0"
})(_boxShadowMixin.default, " background-color:", function (_ref) {
  var selectors = _ref.selectors;
  return selectors.color('white');
}, ";position:relative;opacity:", function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 1 : 0;
}, ";transition:opacity ", function (_ref3) {
  var transitionTime = _ref3.transitionTime;
  return transitionTime;
}, "s;border:1px solid ", function (_ref4) {
  var selectors = _ref4.selectors;
  return selectors.color('accent3');
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
PopoverStyle.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  transitionTime: _propTypes.default.number.isRequired
};

var getArrowDirection = function getArrowDirection(position) {
  return (0, _ArrowContainer.isOnTop)(position) ? _Arrow.ARROW_DIRECTION.UP : _Arrow.ARROW_DIRECTION.DOWN;
};

var Popover = function Popover(_ref5) {
  var arrowPosition = _ref5.arrowPosition,
      children = _ref5.children,
      selectors = _ref5.selectors,
      props = (0, _objectWithoutProperties2.default)(_ref5, ["arrowPosition", "children", "selectors"]);
  return (0, _core.jsx)(PopoverStyle, (0, _extends2.default)({
    selectors: selectors
  }, props), (0, _core.jsx)(_ArrowContainer.default, {
    arrowPosition: arrowPosition
  }, (0, _core.jsx)(_Arrow.default, {
    selectors: selectors,
    arrowDirection: getArrowDirection(arrowPosition)
  })), children);
};

Popover.displayName = 'Popover';
Popover.propTypes = {
  arrowPosition: _propTypes.default.oneOf(Object.values(_constants.ARROW_POSITION)),
  selectors: _propTypes.default.any.isRequired
};
Popover.defaultProps = {
  isOpen: false,
  arrowPosition: _constants.ARROW_POSITION.TOP_LEFT,
  transitionTime: 0.2,
  backgroundColor: 'white'
};
var _default = Popover;
exports.default = _default;